function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
import { CALL_API } from "../middleware/api";
import { urlSearchParams } from "../constants";
export var GET_INVESTMENTPLANS_REQUEST = "GET_INVESTMENTPLANS_REQUEST";
export var GET_INVESTMENTPLANS_SUCCESS = "GET_INVESTMENTPLANS_SUCCESS";
export var GET_INVESTMENTPLANS_FAILURE = "GET_INVESTMENTPLANS_FAILURE";
export var RESET_GET_INVESTMENTPLANS = "RESET_GET_INVESTMENTPLANS";
export var fetchInvestmentPlans = function fetchInvestmentPlans(page, size) {
  var queryString = urlSearchParams({
    page: page,
    size: size,
    sort: "createdAt,desc",
    projection: "withFractions"
  });
  return _defineProperty({}, CALL_API, {
    types: [GET_INVESTMENTPLANS_REQUEST, GET_INVESTMENTPLANS_SUCCESS, GET_INVESTMENTPLANS_FAILURE],
    endpoint: "investmentPlans/search/findAll".concat(queryString),
    init: {
      credentials: "same-origin"
    }
  });
};
export var GET_INVESTMENTPLANSBYIDORNAMECONTAININGANDCURRENCYID_REQUEST = "GET_INVESTMENTPLANSBYIDORNAMECONTAININGANDCURRENCYID_REQUEST";
export var GET_INVESTMENTPLANSBYIDORNAMECONTAININGANDCURRENCYID_SUCCESS = "GET_INVESTMENTPLANSBYIDORNAMECONTAININGANDCURRENCYID_SUCCESS";
export var GET_INVESTMENTPLANSBYIDORNAMECONTAININGANDCURRENCYID_FAILURE = "GET_INVESTMENTPLANSBYIDORNAMECONTAININGANDCURRENCYID_FAILURE";
export var RESET_GET_INVESTMENTPLANSBYIDORNAMECONTAININGANDCURRENCYID = "RESET_GET_INVESTMENTPLANSBYIDORNAMECONTAININGANDCURRENCYID";
export var fetchInvestmentPlansByIdOrNameContainingAndCurrencyId = function fetchInvestmentPlansByIdOrNameContainingAndCurrencyId(page, size, id, name, currencyId) {
  return _defineProperty({}, CALL_API, {
    types: [GET_INVESTMENTPLANSBYIDORNAMECONTAININGANDCURRENCYID_REQUEST, GET_INVESTMENTPLANSBYIDORNAMECONTAININGANDCURRENCYID_SUCCESS, GET_INVESTMENTPLANSBYIDORNAMECONTAININGANDCURRENCYID_FAILURE],
    endpoint: "investmentPlans/search/findByIdOrNameContainingAndCurrencyId".concat(urlSearchParams({
      page: page,
      size: size,
      id: id,
      name: name,
      currencyId: currencyId
    })),
    init: {
      credentials: "same-origin"
    }
  });
};
export var POST_INVESTMENTPLAN_REQUEST = "POST_INVESTMENTPLAN_REQUEST";
export var POST_INVESTMENTPLAN_SUCCESS = "POST_INVESTMENTPLAN_SUCCESS";
export var POST_INVESTMENTPLAN_FAILURE = "POST_INVESTMENTPLAN_FAILURE";
export var RESET_POST_INVESTMENTPLAN = "RESET_POST_INVESTMENTPLAN";
export var postInvestmentPlan = function postInvestmentPlan(investmentPlan) {
  return _defineProperty({
    investmentPlan: investmentPlan
  }, CALL_API, {
    types: [POST_INVESTMENTPLAN_REQUEST, POST_INVESTMENTPLAN_SUCCESS, POST_INVESTMENTPLAN_FAILURE],
    endpoint: "investmentPlans/".concat(investmentPlan.id),
    init: {
      method: "POST",
      headers: {
        "Content-Type": "application/json"
      },
      body: JSON.stringify(investmentPlan),
      credentials: "same-origin"
    }
  });
};
export var resetPostInvestmentPlan = function resetPostInvestmentPlan() {
  return function (dispatch, getState) {
    return dispatch({
      type: RESET_POST_INVESTMENTPLAN
    });
  };
};